// src/components/PopularFlightsCarousel.jsx
// Popular destinations carousel - NO API CALL NEEDED
// Uses curated popular routes with Aviasales deep links
// FIXED: Added safeText to prevent React Error #31
import React, { useState, useEffect, useRef } from 'react';
import './PopularFlightsCarousel.css';

// Safe text helper - prevents React Error #31
const safeText = (value, fallback = '') => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    if (value.city) return String(value.city);
    if (value.name) return String(value.name);
    if (value.code) return String(value.code);
    if (value.text) return String(value.text);
    return fallback;
  }
  return String(value);
};

// ============================================================================
// POPULAR DESTINATIONS DATA (No API needed!)
// ============================================================================
const POPULAR_DESTINATIONS = {
  // From Houston (IAH/HOU)
  'IAH': [
    { code: 'LAX', city: 'Los Angeles', price: 178 },
    { code: 'JFK', city: 'New York', price: 215 },
    { code: 'MIA', city: 'Miami', price: 145 },
    { code: 'LAS', city: 'Las Vegas', price: 125 },
    { code: 'ORD', city: 'Chicago', price: 165 },
    { code: 'DEN', city: 'Denver', price: 142 },
    { code: 'SFO', city: 'San Francisco', price: 198 },
    { code: 'SEA', city: 'Seattle', price: 210 },
    { code: 'CUN', city: 'Cancun', price: 245 },
    { code: 'ATL', city: 'Atlanta', price: 135 },
  ],
  'HOU': [
    { code: 'LAX', city: 'Los Angeles', price: 168 },
    { code: 'LAS', city: 'Las Vegas', price: 118 },
    { code: 'DEN', city: 'Denver', price: 135 },
    { code: 'ORD', city: 'Chicago', price: 155 },
    { code: 'ATL', city: 'Atlanta', price: 125 },
    { code: 'DFW', city: 'Dallas', price: 85 },
  ],
  // From New York (JFK/LGA/EWR)
  'JFK': [
    { code: 'LAX', city: 'Los Angeles', price: 198 },
    { code: 'MIA', city: 'Miami', price: 125 },
    { code: 'LHR', city: 'London', price: 425 },
    { code: 'CDG', city: 'Paris', price: 445 },
    { code: 'CUN', city: 'Cancun', price: 285 },
    { code: 'SFO', city: 'San Francisco', price: 215 },
    { code: 'ORD', city: 'Chicago', price: 95 },
    { code: 'ATL', city: 'Atlanta', price: 115 },
  ],
  'LGA': [
    { code: 'MIA', city: 'Miami', price: 118 },
    { code: 'ORD', city: 'Chicago', price: 89 },
    { code: 'ATL', city: 'Atlanta', price: 105 },
    { code: 'DFW', city: 'Dallas', price: 145 },
    { code: 'BOS', city: 'Boston', price: 75 },
    { code: 'DCA', city: 'Washington DC', price: 85 },
  ],
  // From Los Angeles (LAX)
  'LAX': [
    { code: 'JFK', city: 'New York', price: 198 },
    { code: 'SFO', city: 'San Francisco', price: 75 },
    { code: 'LAS', city: 'Las Vegas', price: 55 },
    { code: 'SEA', city: 'Seattle', price: 95 },
    { code: 'HNL', city: 'Honolulu', price: 298 },
    { code: 'NRT', city: 'Tokyo', price: 650 },
    { code: 'CUN', city: 'Cancun', price: 275 },
    { code: 'ORD', city: 'Chicago', price: 125 },
  ],
  // From Chicago (ORD)
  'ORD': [
    { code: 'LAX', city: 'Los Angeles', price: 125 },
    { code: 'JFK', city: 'New York', price: 95 },
    { code: 'MIA', city: 'Miami', price: 135 },
    { code: 'LAS', city: 'Las Vegas', price: 98 },
    { code: 'DEN', city: 'Denver', price: 85 },
    { code: 'SFO', city: 'San Francisco', price: 145 },
    { code: 'LHR', city: 'London', price: 485 },
    { code: 'CUN', city: 'Cancun', price: 265 },
  ],
  // From Dallas (DFW)
  'DFW': [
    { code: 'LAX', city: 'Los Angeles', price: 125 },
    { code: 'JFK', city: 'New York', price: 175 },
    { code: 'MIA', city: 'Miami', price: 145 },
    { code: 'LAS', city: 'Las Vegas', price: 98 },
    { code: 'DEN', city: 'Denver', price: 95 },
    { code: 'ORD', city: 'Chicago', price: 115 },
    { code: 'CUN', city: 'Cancun', price: 225 },
    { code: 'SFO', city: 'San Francisco', price: 155 },
  ],
  // From Miami (MIA)
  'MIA': [
    { code: 'JFK', city: 'New York', price: 125 },
    { code: 'LAX', city: 'Los Angeles', price: 195 },
    { code: 'ORD', city: 'Chicago', price: 135 },
    { code: 'ATL', city: 'Atlanta', price: 95 },
    { code: 'DFW', city: 'Dallas', price: 145 },
    { code: 'LHR', city: 'London', price: 445 },
    { code: 'MAD', city: 'Madrid', price: 425 },
    { code: 'CUN', city: 'Cancun', price: 175 },
  ],
  // From San Francisco (SFO)
  'SFO': [
    { code: 'LAX', city: 'Los Angeles', price: 75 },
    { code: 'JFK', city: 'New York', price: 215 },
    { code: 'SEA', city: 'Seattle', price: 85 },
    { code: 'LAS', city: 'Las Vegas', price: 65 },
    { code: 'HNL', city: 'Honolulu', price: 285 },
    { code: 'NRT', city: 'Tokyo', price: 598 },
    { code: 'ORD', city: 'Chicago', price: 145 },
    { code: 'DEN', city: 'Denver', price: 95 },
  ],
  // From Atlanta (ATL)
  'ATL': [
    { code: 'JFK', city: 'New York', price: 115 },
    { code: 'LAX', city: 'Los Angeles', price: 175 },
    { code: 'MIA', city: 'Miami', price: 95 },
    { code: 'ORD', city: 'Chicago', price: 105 },
    { code: 'DFW', city: 'Dallas', price: 125 },
    { code: 'LAS', city: 'Las Vegas', price: 145 },
    { code: 'DEN', city: 'Denver', price: 135 },
    { code: 'CUN', city: 'Cancun', price: 235 },
  ],
  // Default fallback
  'DEFAULT': [
    { code: 'LAX', city: 'Los Angeles', price: 189 },
    { code: 'JFK', city: 'New York', price: 229 },
    { code: 'MIA', city: 'Miami', price: 169 },
    { code: 'LAS', city: 'Las Vegas', price: 149 },
    { code: 'ORD', city: 'Chicago', price: 179 },
    { code: 'DEN', city: 'Denver', price: 159 },
    { code: 'SFO', city: 'San Francisco', price: 199 },
    { code: 'SEA', city: 'Seattle', price: 209 },
  ],
};

const TRAVELPAYOUTS_MARKER = '689249';

const PopularFlightsCarousel = ({ userLocation, onFlightSelect }) => {
  const [flights, setFlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const trackRef = useRef(null);

  // Safe extraction of userLocation properties
  const userAirport = safeText(userLocation?.airport) || safeText(userLocation?.nearbyAirports?.[0]?.code) || 'IAH';
  const userCity = safeText(userLocation?.city) || 'Houston';

  useEffect(() => {
    loadPopularDestinations();
  }, [userAirport]);

  const loadPopularDestinations = () => {
    setLoading(true);
    
    // Small delay to show loading state (feels more real)
    setTimeout(() => {
      // Get destinations for this airport, or use default
      const destinations = POPULAR_DESTINATIONS[userAirport] || POPULAR_DESTINATIONS['DEFAULT'];
      
      // Filter out user's current airport if it appears
      const filtered = destinations.filter(d => safeText(d.code) !== userAirport);
      
      // Generate dates (2-3 weeks from now)
      const today = new Date();
      const departDate = new Date(today);
      departDate.setDate(today.getDate() + 14 + Math.floor(Math.random() * 7));
      const returnDate = new Date(departDate);
      returnDate.setDate(departDate.getDate() + 5 + Math.floor(Math.random() * 4));
      
      // Build flight objects with deep links
      const flightData = filtered.slice(0, 8).map(dest => {
        // Add slight price variation to look dynamic
        const priceVariation = Math.floor(Math.random() * 30) - 15;
        const finalPrice = Math.max((dest.price || 100) + priceVariation, 49);
        
        // Build Aviasales deep link
        const deepLink = buildAviasalesLink(userAirport, safeText(dest.code), departDate, returnDate);
        
        return {
          origin: userAirport,
          destination: { code: safeText(dest.code), city: safeText(dest.city) },
          departureDate: departDate.toISOString().split('T')[0],
          returnDate: returnDate.toISOString().split('T')[0],
          price: finalPrice,
          travelers: 1,
          class: 'Economy',
          deepLink: deepLink
        };
      });
      
      setFlights(flightData);
      setLoading(false);
    }, 300);
  };

  const buildAviasalesLink = (origin, destination, departDate, returnDate) => {
    const formatDate = (date) => {
      return `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}`;
    };
    
    const depDDMM = formatDate(departDate);
    const retDDMM = formatDate(returnDate);
    const searchPath = `${safeText(origin)}${depDDMM}${safeText(destination)}${retDDMM}1`;
    
    return `https://www.aviasales.com/search/${searchPath}?marker=${TRAVELPAYOUTS_MARKER}`;
  };

  const scroll = (direction) => {
    if (trackRef.current) {
      const scrollAmount = 140;
      trackRef.current.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleFlightClick = (flight) => {
    // Open Aviasales deep link
    if (flight.deepLink) {
      window.open(flight.deepLink, '_blank', 'noopener,noreferrer');
    }
    
    // Also trigger callback if provided
    if (onFlightSelect) {
      onFlightSelect({
        origin: safeText(flight.origin),
        destination: safeText(flight.destination?.code),
        destinationCity: safeText(flight.destination?.city),
        departureDate: safeText(flight.departureDate),
        returnDate: safeText(flight.returnDate),
        price: flight.price,
        travelers: flight.travelers,
        class: flight.class
      });
    }
  };

  const formatShortDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr + 'T00:00:00');
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch {
      return safeText(dateStr);
    }
  };

  return (
    <div className="popular-carousel">
      {/* Header */}
      <div className="carousel-head">
        <span className="carousel-icon">🔥</span>
        <span className="carousel-title">Popular Destinations from {userCity}</span>
      </div>

      {/* Carousel Container */}
      <div className="carousel-body">
        {/* Loading */}
        {loading && (
          <div className="carousel-loading">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="skeleton-card" />
            ))}
          </div>
        )}

        {/* Flight Cards */}
        {!loading && flights.length > 0 && (
          <>
            <button 
              className="carousel-arrow prev" 
              onClick={() => scroll('prev')}
              aria-label="Previous"
            >
              ‹
            </button>

            <div className="carousel-track" ref={trackRef}>
              {flights.map((flight, index) => (
                <div 
                  key={index} 
                  className="dest-card"
                  onClick={() => handleFlightClick(flight)}
                >
                  <div className="dest-city">{safeText(flight.destination?.city, 'Destination')}</div>
                  <div className="dest-dates">
                    {formatShortDate(flight.departureDate)} → {formatShortDate(flight.returnDate)}
                  </div>
                  <div className="dest-meta">
                    <span className="dest-travelers">1 Traveler • Economy</span>
                  </div>
                  <div className="dest-price-row">
                    <span className="dest-from">from</span>
                    <span className="dest-price">${Math.round(flight.price || 0)}</span>
                  </div>
                </div>
              ))}
            </div>

            <button 
              className="carousel-arrow next" 
              onClick={() => scroll('next')}
              aria-label="Next"
            >
              ›
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PopularFlightsCarousel;
